module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/assets/bootstrap/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/bootstrap/fonts/glyphicons-halflings-regular.woff
// module chunks = styles